/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerSpitchCreate
 */
export interface SingleTurnChatInferencerSpitchCreate {
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  spitchEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  spitchUserId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  spitchChannelId: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerSpitchCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerSpitchCreate interface.
 */
export function instanceOfSingleTurnChatInferencerSpitchCreate(
  value: object,
): value is SingleTurnChatInferencerSpitchCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('spitchEndpoint' in value) || value['spitchEndpoint'] === undefined) return false;
  if (!('spitchUserId' in value) || value['spitchUserId'] === undefined) return false;
  if (!('spitchChannelId' in value) || value['spitchChannelId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerSpitchCreateFromJSON(json: any): SingleTurnChatInferencerSpitchCreate {
  return SingleTurnChatInferencerSpitchCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerSpitchCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerSpitchCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    spitchEndpoint: json['spitch_endpoint'],
    spitchUserId: json['spitch_user_id'],
    spitchChannelId: json['spitch_channel_id'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerSpitchCreateToJSON(value?: SingleTurnChatInferencerSpitchCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    spitch_endpoint: value['spitchEndpoint'],
    spitch_user_id: value['spitchUserId'],
    spitch_channel_id: value['spitchChannelId'],
    credential_id: value['credentialId'],
  };
}
